import { cva, type VariantProps } from 'class-variance-authority';
import type { FC, ReactNode } from 'react';
import { cn } from '../lib/utils';

export const calloutVariants = cva('rounded-[12px] border px-4 py-3', {
  variants: {
    tone: {
      brand: 'border-brand-border bg-brand-subtle [--callout-label:var(--z-brand)]',
      warning: 'border-warning bg-warning-subtle [--callout-label:var(--z-warning)]',
      danger:
        'border-[color:var(--z-danger)] bg-danger-subtle [--callout-label:var(--z-danger-foreground)]',
      info: 'border-info bg-info-subtle [--callout-label:var(--z-info)]'
    }
  },
  defaultVariants: { tone: 'brand' }
});

interface CalloutProps extends VariantProps<typeof calloutVariants> {
  /** Small upper-case label above the message: `IN PLAIN LANGUAGE`, `SQL ONLY`. */
  label: string;
  children: ReactNode;
  className?: string;
}

/** A labelled, tinted note: what something does, or what it can't. */
export const Callout: FC<CalloutProps> = ({ label, tone, children, className }) => (
  <div className={cn(calloutVariants({ tone }), className)}>
    <p className="text-eyebrow-sm text-[color:var(--callout-label)] uppercase">{label}</p>
    <div className="mt-1 text-body text-foreground">{children}</div>
  </div>
);
